import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';
import { AbSelect } from '../../components/ui';
import type { Field } from '../types';
import { getAttributeValue, isOptionsArray } from '../utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormFieldSelect',
  props: {
    value: null,
    field: null,
    error: null,
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any) {

const props = __props as {
  value: any;
  field: Field;
  error?: string;
  disabled?: boolean;
};





const selectOptions = computed(() => {
  const options = getAttributeValue(props.field, 'options');
  if (isOptionsArray(options)) {
    return options.map((option) => ({
      value: option.value,
      text: option.label,
    }));
  }
  return [];
});

const label = computed(() => {
  const value = getAttributeValue(props.field, 'label');
  return typeof value === 'string' ? value : '';
});

const placeholder = computed(() => {
  const value = getAttributeValue(props.field, 'placeholder');
  return typeof value === 'string' ? value : '';
});

return { __sfc: true,props, selectOptions, label, placeholder, AbSelect }
}

})